import React, { FC, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import SignupForm from './SignupForm'
import LoginLayout from '../layout'
import './styles.scss'

interface MatchParams {
  email: string
}

interface Props extends RouteComponentProps<MatchParams> {
  setLoginStage: (loginStage: 'reset' | 'signup') => void
}

const Signup: FC<Props> = ({ match, setLoginStage }) => {
  const [signupSuccess, setSignupSuccess] = useState(false)
  let { email } = match.params
  if (!email) {
    email = ''
  }

  return (
    <LoginLayout>
      <Row className="title">
        <Col>
          <h2>Welcome to Maverick!</h2>
        </Col>
      </Row>
      {signupSuccess ? (
        <Row className="feedback">
          <Col>
            <h4>Signup Successful!</h4>
            <h5>
              Check your email for a confirmation code and then log into Maverick. You will be
              prompted to submit your confirmation code after logging in.
            </h5>
          </Col>
        </Row>
      ) : (
        <Row className="form">
          <Col>
            <h4>Sign up here.</h4>
            <SignupForm
              setSignupSuccess={setSignupSuccess}
              email={email.toLowerCase()}
              setLoginStage={setLoginStage}
            />
          </Col>
        </Row>
      )}
    </LoginLayout>
  )
}

export default withRouter(Signup)
